import React from "react";
import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { LayoutDashboard, CalendarCheck, BookOpen, Star, Mail, FileBarChart, ListChecks, Settings, LogOut, Receipt, Milestone, Flower2, LayoutTemplate } from "lucide-react";

const LINKS = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/bookings", label: "Bookings", icon: CalendarCheck },
  { to: "/admin/journeys", label: "Journeys", icon: Milestone },
  { to: "/admin/programs", label: "Programs", icon: BookOpen },
  { to: "/admin/homepage", label: "Homepage Offer", icon: LayoutTemplate },
  { to: "/admin/meditations", label: "Digital Meditations", icon: Flower2 },
  { to: "/admin/testimonials", label: "Testimonials", icon: Star },
  { to: "/admin/email-templates", label: "Email Templates", icon: Mail },
  { to: "/admin/payment-logs", label: "Payment Logs", icon: Receipt },
  { to: "/admin/email-logs", label: "Communications", icon: ListChecks },
  { to: "/admin/reports", label: "Reports & Export", icon: FileBarChart },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const handleLogout = async () => { await logout(); nav("/admin/login"); };

  return (
    <div className="admin-shell grid grid-cols-[260px_1fr] min-h-screen">
      <aside className="admin-side flex flex-col py-6 px-3 sticky top-0 h-screen">
        <Link to="/admin" className="px-3 mb-8">
          <div className="font-serif text-2xl text-terracotta">iChaitanya</div>
          <div className="text-[10px] uppercase tracking-[0.25em] text-[#EBE5D9]/70">Admin Console</div>
        </Link>
        <nav className="flex-1 space-y-0.5">
          {LINKS.map(l => {
            const I = l.icon;
            return (
              <NavLink key={l.to} to={l.to} end={l.end} data-testid={`side-${l.label.toLowerCase().replace(/\s+/g,"-")}`}
                className={({isActive}) =>
                  `flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm transition ${isActive ? "active" : ""}`
                }>
                <I size={16}/>{l.label}
              </NavLink>
            );
          })}
        </nav>
        <div className="border-t border-[#5C4A3F] mt-4 pt-4 px-3">
          <div className="text-xs text-[#EBE5D9]/80">{user?.email}</div>
          <button onClick={handleLogout} data-testid="admin-logout"
            className="mt-3 inline-flex items-center gap-2 text-xs text-[#EBE5D9] hover:text-white">
            <LogOut size={14}/> Logout
          </button>
        </div>
      </aside>
      <main className="px-8 py-8 overflow-x-auto">
        <Outlet/>
      </main>
    </div>
  );
}
